@if (data.platform === 'google') {
  <div class="info-container">
    <div class="image">
      <img src="imgs/icon.png" class="logo-icon" alt="Application icon">
    </div>
    <div class="text-container">
      <div mat-dialog-title class="title">{{ data.title | translate }}</div>
      <div class="message">{{ data.message | translate }}</div>  
    </div>
  </div>
  <div class="actions-container">
    <app-button
      [buttonLabel]="'buttons.skip' | translate"
      [buttonType]="BUTTON_TYPES.OUTLINED" 
      [buttonDisabled]="false"
      (click)="action('cancel')">
    </app-button>
    <app-button
      [buttonLabel]="'buttons.install' | translate"
      [buttonType]="BUTTON_TYPES.REGULAR" 
      [buttonDisabled]="false"
      (click)="action('continue')">
    </app-button>
  </div>
}@else if (data.platform === 'apple') {
  <div class="info-container">
    <div class="image">
      <img src="imgs/icon.png" class="logo-icon" alt="Application icon">
    </div>
    <div class="text-container">
      <div class="title">{{ data.title | translate }}</div>
      <div class="message">{{ data.message | translate }}</div>
    </div>
  </div>
  <div class="actions-container-ios">
      <span>{{'pwa-install-dialog.ios_message_1' | translate}}
        <img src="imgs/ios-share.webp" class="logo-icon" alt="Share icon">
        {{'pwa-install-dialog.ios_message_2' | translate}} &nbsp;<strong>{{'pwa-install-dialog.ios_message_3' | translate}}</strong>
      </span>
  </div>
}